import React from 'react';
import PropTypes from 'prop-types';

import { StyledTourCardContentContainer } from './StyledComponents';

const propTypes = {
    children: PropTypes.node.isRequired,
    size: PropTypes.oneOf(['sm', 'md']),
};

const defaultProps = {
    size: 'sm',
};

const TourCardContentContainer = ({
    children,
    size,
}) => (
    <StyledTourCardContentContainer padding={size === 'sm' ? 'xs' : 'sm'}>
        {children}
    </StyledTourCardContentContainer>
);

TourCardContentContainer.propTypes = propTypes;
TourCardContentContainer.defaultProps = defaultProps;

export default TourCardContentContainer;
